import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled from 'styled-components';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/constants/Breakpoints';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
export const borderStyle = `1px solid ${GREAT_WHITE}`;
export const Section = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__Section",
  componentId: "sc-1pwleyq-0"
})(["", ""], breakpoint.tablet(_t || (_t = _`
    border-right: none !important;
    border-bottom: ${0};
  `), ({
  showBorderBottom
}) => showBorderBottom ? borderStyle : undefined));
export const FillerRow = ({
  row,
  commonStyles
}) => /*#__PURE__*/_jsx("div", {
  style: Object.assign({
    gridRowStart: row
  }, commonStyles)
});
/* stylelint-disable property-no-vendor-prefix */

export const StyledCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__StyledCardGrid",
  componentId: "sc-1pwleyq-1"
})(["display:grid;grid-template-columns:repeat( ", ",calc( (100% / ", ") - ", "px ) );background:", ";max-width:", ";width:100%;column-gap:", ";box-shadow:", ";", " @media (max-width:", "px){max-width:", ";}", ";@media (min-width:", "px) and (max-width:", "px){min-width:600px;width:100% !important;}", ";"], ({
  columns
}) => columns, ({
  columns
}) => columns, ({
  columns,
  columnGap = 16
}) => columnGap * (columns - 1) / columns, OLAF, ({
  columns
}) => {
  return columns < 3 ? `calc(100% / 3 * ${columns})` : 'initial';
}, ({
  columnGap
}) => {
  return columnGap ? `${columnGap}px` : '16px';
}, ({
  isEbx633
}) => !isEbx633 && '0 1px 5px 0 #2d3e501f', ({
  isEbx633
}) => isEbx633 && `max-width: 70%;`, breakpointValues.sd - 1, ({
  isEbx633
}) => isEbx633 && '80%', breakpoint.tablet(_t2 || (_t2 = _`
    max-width: initial;
    width: 80% !important;
    margin-top: 20px;
  `)), breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t3 || (_t3 = _`
    max-width: initial;
    width: 94% !important;
  `)));